import { render, staticRenderFns } from "./DeadlineMonitoringTabPhysicals.vue?vue&type=template&id=fa9e1ede"
import script from "./DeadlineMonitoringTabPhysicals.vue?vue&type=script&lang=js"
export * from "./DeadlineMonitoringTabPhysicals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports